import { AuthenticatedRouteProvider } from "@/context/authenticated-route";
import { routeLoaderApiClient } from "@/lib/api";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-actor")({
  beforeLoad: async (context) => {
    const res = await routeLoaderApiClient.actor.$get();
    if (res.ok === false) {
      throw new Error("Failed to fetch actor");
    }

    const { actor } = await res.json();
    if (actor == null) {
      const isSigneringsportal = context.location.pathname === "/signer";

      throw redirect({
        to: "/login",
        search: {
          url: window.location.href,
          type: isSigneringsportal ? "signeringsportal" : undefined,
        },
      });
    }
  },
  component: AuthenticatedActorRoute,
});

function AuthenticatedActorRoute() {
  return (
    <AuthenticatedRouteProvider type="actor">
      <Outlet />
    </AuthenticatedRouteProvider>
  );
}
